export enum Types {
  UPDATE = "TAB_BAR_UPDATE",
}

export type Action = UpdateTabBar

export type UpdateTabBar = {
  payload: { index: number }
  type: Types.UPDATE
}

export function updateTabbarIndex(index: number): UpdateTabBar {
  return {
    payload: { index },
    type: Types.UPDATE,
  }
}
